// Create module-level formatters Map that persists between function calls
const formatters = new Map()

export default (amount, options = {}, locale = 'en-US', currency = 'USD') => {
  if (!formatters.has(currency)) {
    formatters.set(currency, new Intl.NumberFormat(locale, {
      style: 'currency',
      currencyDisplay: 'symbol',
      currency,
      ...options,
    }))
  }

  // Properly access Map with get() method
  return formatters.get(currency).format(amount)
}
